export default __webpack_public_path__ + "static/media/warning.37c711a1.svg";